export const PLANHOPPER_ORG_ID = "550e8400-e29b-41d4-a716-446655440000"

export const WHATSAPP_NUMBER = 34622235597
